/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Deployment, Deployment$inboundSchema } from "./deployment.js";

export type CreateDeploymentResult = {
  deployment?: Deployment | undefined;
};

/** @internal */
export const CreateDeploymentResult$inboundSchema: z.ZodMiniType<
  CreateDeploymentResult,
  unknown
> = z.object({
  deployment: z.optional(Deployment$inboundSchema),
});

export function createDeploymentResultFromJSON(
  jsonString: string,
): SafeParseResult<CreateDeploymentResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateDeploymentResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateDeploymentResult' from JSON`,
  );
}
